import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { TAGS_QUERY } from '../../queries';

export function useAllTagsQuery( options ) {

    const { data: rawData, loading, error, refetch } = useQuery( TAGS_QUERY, {
        fetchPolicy: 'network-only',
        ...options 
    } );

    return useMemo( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
        };
    }, [ error, loading, rawData, refetch ] );
}
